import classNames from 'classnames';
import styles from './Typography.module.css';

interface TypographyProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?:
    | 'titleLarge'
    | 'bodyLarge'
    | 'bodyMedium'
    | 'bodySmall'
    | 'labelLarge'
    | 'labelMedium'
    | 'labelSmall'
    | 'helper';
}

const Typography = ({
  variant = 'bodyMedium',
  className,
  ...props
}: TypographyProps): JSX.Element => {
  return (
    <span
      className={classNames(className, styles.typography, {
        [styles.titleLarge]: variant === 'titleLarge',
        [styles.bodyLarge]: variant === 'bodyLarge',
        [styles.bodyMedium]: variant === 'bodyMedium',
        [styles.bodySmall]: variant === 'bodySmall',
        [styles.labelLarge]: variant === 'labelLarge',
        [styles.labelMedium]: variant === 'labelMedium',
        [styles.labelSmall]: variant === 'labelSmall',
        [styles.helper]: variant === 'helper',
      })}
      {...props}
    >
      {props.children}
    </span>
  );
};

export default Typography;
